export const PersistStorageKeys = {
  dispatchState: 'dispatchState',
};
